import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Dashboard() {
const { user, logout } = useAuth();
//const handleLogoutClick = () => {
      //logout();    
  //};

const userData = JSON.parse(localStorage.getItem('userData'));

let userLastName = userData?.userDetails?.[0]?.lastName;
let useFastName = userData?.userDetails?.[0]?.firstName;
console.log('useFastName', useFastName);
let userRole = userData?.generalDetails?.userType?.toLowerCase();
  const [role, setRole] = useState(userRole); // 'client' or 'staff'

  return (
    <div className="bg-light mt-5" style={{ minHeight: '100vh' }}>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container-fluid">
          <span className="navbar-brand">
            Homeward Bound Midwifery Services
          </span>
          <div className="d-flex align-items-center">
            <span className="text-white me-3">
              Welcome, {userLastName} {useFastName} <span className="role-badge badge bg-danger text-primary">
                {role.charAt(0).toUpperCase() + role.slice(1)}
              </span>
            </span>
            <div className="dropdown">
              <button className="btn btn-light dropdown-toggle" type="button" 
                id="dropdownMenuButton" data-bs-toggle="dropdown">
                <i className="bi bi-person-circle"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li><a className="dropdown-item" href="#"><i className="bi bi-person me-2"></i>Profile</a></li>
                <li><a className="dropdown-item" href="#"><i className="bi bi-gear me-2"></i>Settings</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li onClick={() => logout()} ><a className="dropdown-item text-danger" href="#"><i className="bi bi-box-arrow-right me-2"></i>Logout</a></li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      {/* Demo Role Switcher - Remove in production 
      <div className="container-fluid mt-2">
        <div className="alert alert-info">
          Demo Role Switch: 
          <button className="btn btn-sm btn-primary mx-2" onClick={() => setRole('client')}>Client View</button>
          <button className="btn btn-sm btn-secondary" onClick={() => setRole('staff')}>Staff View</button>
        </div>
      </div>
      */}

      {/* Dashboard Content */}
      <div className="container-fluid mt-4">
        {/* Client View */}
        {role === 'client' && (
          <div className="row g-4">
          {/* Upcoming Appointments */}
          <div className="col-12 col-lg-5 mb-5 d-flex flex-column">
            <div className="card dashboard-card shadow-sm h-100">
              <div className="card-header bg-info text-white">
                <i className="bi bi-calendar-check me-2"></i>Upcoming Appointments
              </div>
              <div className="card-body d-flex flex-column">
                <div className="list-group flex-grow-1">
                  <a href="#" className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between">
                      <h6 className="mb-1">Prenatal Checkup</h6>
                      <small>Nov 15, 2023</small>
                    </div>
                    <small>2:00 PM - With Midwife Jane</small>
                  </a>
                  <a href="#" className="list-group-item list-group-item-action">
                    <div className="d-flex w-100 justify-content-between">
                      <h6 className="mb-1">Ultrasound Scan</h6>
                      <small>Nov 22, 2023</small>
                    </div>
                    <small>10:00 AM - Imaging Center</small>
                  </a>
                </div>
              </div>
            </div>
          </div>
        
          {/* Quick Actions */}
          <div className="col-12 col-lg-7 mb-5 d-flex flex-column">
        <div className="card dashboard-card shadow-sm h-100">
          <div className="card-header bg-success text-white">
            <i className="bi bi-lightning-charge me-2"></i>Quick Actions
          </div>
          <div className="card-body d-flex flex-column">
            <div className="row g-3 text-center flex-grow-1">
              <div className="col-6 col-md-3">
                <Link to="/messages" className="btn btn-outline-success w-100 h-100">
                  <i className="bi bi-chat-dots fs-4 d-block mb-2"></i>
                  Message
                </Link>
              </div>
              <div className="col-6 col-md-3">
                <Link to="/forms" className="btn btn-outline-success w-100 h-100">
                  <i className="bi bi-file-medical fs-4 d-block mb-2"></i>
                  Forms
                </Link>
              </div>
              <div className="col-6 col-md-3">
                <Link to="/payments" className="btn btn-outline-success w-100 h-100">
                  <i className="bi bi-cash fs-4 d-block mb-2"></i>
                  Payments
                </Link>
              </div>
              <div className="col-6 col-md-3">
                <Link to="/consent" className="btn btn-outline-success w-100 h-100">
                  <i className="bi bi-shield-check fs-4 d-block mb-2"></i>
                  Consent
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
        
          {/* Health Overview */}
          <div className="col-12 col-lg-4 mb-5 d-flex flex-column">
            <div className="card dashboard-card shadow-sm h-100">
              <div className="card-header bg-warning text-dark">
                <i className="bi bi-heart-pulse me-2"></i>Health Overview
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between">
                    <span>Weeks Pregnant:</span>
                    <strong>28</strong>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span>Next Due Date:</span>
                    <strong>Feb 20, 2024</strong>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span>Blood Pressure:</span>
                    <strong>120/80 mmHg</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        
          {/* Educational Resources */}
          <div className="col-12 col-lg-8 mb-5 d-flex flex-column">
        <div className="card dashboard-card shadow-sm h-100">
          <div className="card-header bg-purple text-white">
            <i className="bi bi-journal-bookmark me-2"></i>Educational Resources
          </div>
          <div className="card-body d-flex flex-column">
            <div className="row g-3 flex-grow-1">
              <div className="col-md-4 d-flex">
                <Link to="/prenatal-classes" className="card h-100 w-100 text-decoration-none">
                  <div className="card-body text-center">
                    <i className="bi bi-camera-video fs-2 text-primary"></i>
                    <h6 className="mt-2">Prenatal Classes</h6>
                  </div>
                </Link>
              </div>
              <div className="col-md-4 d-flex">
                <Link to="/nutrition-guide" className="card h-100 w-100 text-decoration-none">
                  <div className="card-body text-center">
                    <i className="bi bi-book fs-2 text-success"></i>
                    <h6 className="mt-2">Nutrition Guide</h6>
                  </div>
                </Link>
              </div>
              <div className="col-md-4 d-flex">
                <Link to="/birth-plan" className="card h-100 w-100 text-decoration-none">
                  <div className="card-body text-center">
                    <i className="bi bi-file-text fs-2 text-info"></i>
                    <h6 className="mt-2">Birth Plan Template</h6>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    


        </div>
        )}

        {/* Staff View */}
        {role === 'staff' && (
          <div className="row g-4 align-items-stretch">
          {/* Patients Overview */}
          <div className="col-12 col-lg-4 mt-3 d-flex">
            <div className="card dashboard-card shadow-sm w-100">
              <div className="card-header bg-primary text-white">
                <i className="bi bi-people me-2"></i>Patients Overview
              </div>
              <div className="card-body d-flex flex-column">
                <div className="row text-center flex-grow-1">
                  <div className="col-6">
                    <h3>24</h3>
                    <small>Active Patients</small>
                  </div>
                  <div className="col-6">
                    <h3>3</h3>
                    <small>Due This Week</small>
                  </div>
                </div>
                <hr />
                <div className="row text-center flex-grow-1">
                  <div className="col-6">
                    <h3>5</h3>
                    <small>New This Month</small>
                  </div>
                  <div className="col-6">
                    <h3>2</h3>
                    <small>Postpartum</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          {/* Schedule */}
          <div className="col-12 col-lg-8 mt-3 d-flex">
            <div className="card dashboard-card shadow-sm w-100">
              <div className="card-header bg-success text-white">
                <i className="bi bi-calendar2-range me-2"></i>Schedule
              </div>
              <div className="card-body d-flex flex-column">
                <div className="table-responsive flex-grow-1">
                  <table className="table table-hover m-0">
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>Patient</th>
                        <th>Type</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>9:00 AM</td>
                        <td>Sarah Johnson</td>
                        <td>Prenatal Checkup</td>
                        <td><span className="badge bg-success">Confirmed</span></td>
                      </tr>
                      <tr>
                        <td>11:00 AM</td>
                        <td>Emily Chen</td>
                        <td>Postpartum Visit</td>
                        <td><span className="badge bg-warning text-dark">Pending</span></td>
                      </tr>
                      <tr>
                        <td>2:00 PM</td>
                        <td>Maria Gonzalez</td>
                        <td>Initial Consultation</td>
                        <td><span className="badge bg-info">New</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        
          {/* Tasks & Alerts */}
          <div className="col-12 mt-3 d-flex">
            <div className="card dashboard-card shadow-sm w-100">
              <div className="card-header bg-danger text-white">
                <i className="bi bi-bell me-2"></i>Tasks & Alerts
              </div>
              <div className="card-body d-flex flex-column">
                <div className="flex-grow-1">
                  <div className="alert alert-warning d-flex align-items-center">
                    <i className="bi bi-exclamation-triangle fs-4 me-3"></i>
                    <div>2 patients need follow-up</div>
                  </div>
                  <div className="alert alert-info d-flex align-items-center">
                    <i className="bi bi-info-circle fs-4 me-3"></i>
                    <div>3 new patient applications</div>
                  </div>
                  <div className="alert alert-danger d-flex align-items-center">
                    <i className="bi bi-urgency-high fs-4 me-3"></i>
                    <div>1 overdue lab result</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>

      <style>{`
        .dashboard-card {
          transition: transform 0.2s;
          min-height: 200px;
        }
        .dashboard-card:hover {
          transform: translateY(-5px);
        }
        .role-badge {
          font-size: 0.75rem;
          vertical-align: super;
        }
        .bg-purple {
          background-color: #6f42c1;
        }
      `}</style>
    </div>
  );
}

export default Dashboard;